<template>
  <div v-if="showBanner" class="fixed bottom-0 left-0 right-0 bg-primary shadow-lg border-t border-gray-200 p-4 z-50">
    <div class="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
      <div class="text-sm text-white">
        <p>Nous utilisons des cookies pour améliorer votre expérience de navigation, proposer du contenu personnalisé et analyser notre trafic. En cliquant sur « Accepter », vous consentez à l’utilisation de ces cookies.</p>
      </div>
      <div class="flex flex-wrap gap-4">
        <button
          @click="handleReject"
          class="px-4 py-2 text-sm font-medium text-white border border-white rounded-md transition-colors"
        >
        Refuser
        </button>
        <button
          @click="handleAccept"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        >
        Accepter
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent')
    if (!cookieConsent) {
      this.showBanner = true
    }
  },
  methods: {
    handleAccept() {
      localStorage.setItem('cookieConsent', 'accepted')
      this.showBanner = false
    },
    handleReject() {
      localStorage.setItem('cookieConsent', 'rejected')
      this.showBanner = false
    }
  }
}
</script> 